// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"8f58c0a5","144":"b4dcc0b2"}[chunkId] + ".chunk.css";
};